import { React, useState, useRef, useCallback } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import Checkbox, { CheckboxGroup } from '@iso/components/uielements/checkbox';
import Box from '@iso/components/utility/box';
import ContentHolder from '@iso/components/utility/contentHolder';
import Button from '@iso/components/uielements/button';
import Input, {
    InputSearch,
    InputGroup,
    Textarea,
} from '@iso/components/uielements/input';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { useContext } from 'react';
import { AppContext } from '../../../context/ContextProvider';
import styled, { createGlobalStyle } from 'styled-components';
import Select, { SelectOption } from '@iso/components/uielements/select';
import initialData from '../../../redux/scrumBoard/data';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AlertContext } from '../../../context/alertContext';
import awsIcon from '@iso/assets/images/icon/aws-logo.svg';
import api from '../../../api';
import { credsManagementContext, formatErrors } from '../../../context/helper';
import { Form, Spin, Tooltip } from 'antd';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import CreateTaskFooter from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';

const Option = SelectOption;

const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }
`;

const LoaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const serverInsTypes = ["t3.small", "m4.large", "c5.large", "r3.large"];
serverInsTypes.map((child, ind) => {
    serverInsTypes.push(<Option key={child} name="serverInsType" value={child}>{child}</Option>);
});

var optionAzs = [];

const initialErrors = {
    status: false,
    content: {}
}

const permissionColumns = [
    { key: "create_repository", label: "Create Repo" },
    { key: "push_image", label: "Push" },
    { key: "list_images", label: "List" },
    { key: "pull_image", label: "Pull" },
    { key: "get_image", label: "Get Image" },
    { key: "delete_repository", label: "Delete Repo" }
];

const permissionTooltips = {
    create_repository: "Grant iam:Action ecr:CreateRepository for this credential.",
    push_image: "Grant ecr:PutImage to allow pushing images.",
    list_images: "Grant ecr:ListImages so repositories can list images.",
    pull_image: "Grant ecr:BatchGetImage for pulling images.",
    get_image: "Grant ecr:DescribeImages (image metadata).",
    delete_repository: "Grant ecr:DeleteRepository to delete repositories."
};

export default function EcrIntgration({
    // handleSubmit,
    data,
    load,
    setLoad,
    connected,
    setConnected,
    onCancel,
    onDelete,
    openDrawer,
    onEditCancel,
    tabSelected,
    openAddOns
}) {

    const { setOpenRightDrawer } = useContext(AppContext);
    const { set_alertOptions } = useContext(AlertContext);
    const navigate = useNavigate();

    // Helper function for alerts
    const toggleAlert = (type, message, description) => {
        set_alertOptions({
            status: true,
            type: type,
            message: message,
            description: description
        });
        setTimeout(() => {
            set_alertOptions(prev => ({ ...prev, status: false }));
        }, 5000);
    };

    const [ecrData, setEcrData] = useState({
        selectionType: "account_id", // "account_id" or "credentials"
        accountId: [],
        region: [],
        credentialId: null
    });

    const [allAccountIds, setAllAccountIds] = useState([]);
    const [allRegions, setAllRegions] = useState([]);
    const [allCredentials, setAllCredentials] = useState([]);
    const [isValidated, setIsValidated] = useState(false);
    const [validating, setValidating] = useState(false);
    const [connecting, setConnecting] = useState(false);

    const [error, setError] = useState({ ...initialErrors });

    const [form] = Form.useForm();
    const abortControllersRef = useRef(new Set());

    const registerAbortController = () => {
        const controller = new AbortController();
        abortControllersRef.current.add(controller);
        return controller;
    };

    const unregisterAbortController = (controller) => {
        if (controller) {
            abortControllersRef.current.delete(controller);
        }
    };

    const abortAllPendingRequests = useCallback(() => {
        abortControllersRef.current.forEach((controller) => controller.abort());
        abortControllersRef.current.clear();
    }, []);

    useEffect(() => {
        // Fetch credentials list
        fetchCredentialsList();
        
        // Set initial form values
        form.setFieldsValue({
            selectionType: "account_id",
            accountId: [],
            region: [],
            credentialId: null
        });
    }, []);

    useEffect(() => {
        console.log("data :", data);
        console.log("initialData :", initialData);
        let accountIds = [];
        let regions = [];
        // accountIds
        data?.map((temp, ind) => {
            if (temp.integration_type === "aws" && temp.integration_state && temp.integration_state.toLowerCase() === "active") {
                accountIds.push(
                    <Option key={temp.account_id} name="accountId" data-alias={temp.alias} type={temp.integration_type} value={temp.account_id}>
                        <div name="accountId" style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                            <img src={awsIcon} style={{ width: "18px", height: "18px", marginRight: "10px" }} alt="provider" />
                            <span name="accountId">{`${temp.account_id}${temp.alias ? ` (${temp.alias})` : ""}`}</span>
                        </div>
                    </Option>
                );
            }
        });

        // Integrate New Account on no aws account found
        // if (accountIds.length >= 0) {
        //     accountIds.push(
        //         <Option key={data.length} name="accountId" data-alias="" type="integration" style={{ color: "white", background: "#1677ff" }}>
        //             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "40px" }}>
        //                 <span>Integrate New Account</span>
        //             </div>
        //         </Option>
        //     );
        // }

        // regions
        Object.keys(initialData.regions["aws"])?.map((child, ind) => {
            regions.push(<Option key={child + "-" + ind} name="region" value={child}>
                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", width: "100%" }}>
                    <span>{`${initialData.regions["aws"][child].name} / ${child}`}</span>
                </div>
            </Option>);
        });

        setAllAccountIds([...accountIds]);
        setAllRegions([...regions]);
    }, []);

    useEffect(() => {
        return () => {
            abortAllPendingRequests();
        };
    }, [abortAllPendingRequests]);

    const fetchCredentialsList = async () => {
        const controller = registerAbortController();
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URI}/api/admin/credentials/create/`, {
                signal: controller.signal,
            });
            if (response.data.status && response.data.data.results) {
                let credentials = [];
                response.data.data.results.forEach((cred) => {
                    // Only show AWS credentials with assume_role auth method
                    if (cred.provider?.toLowerCase() === "aws" && cred.status?.toLowerCase() === "active") {
                        const accountId = cred.configuration?.account_id || "";
                        credentials.push(
                            <Option key={cred.id} name="credentialId" value={cred.id} data-accountid={accountId} data-region={cred.configuration?.region}>
                                <div name="credentialId" style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                                    <img src={awsIcon} style={{ width: "18px", height: "18px", marginRight: "10px" }} alt="provider" />
                                    <span name="credentialId">{`${cred.name}${accountId ? ` (${accountId})` : ""}`}</span>
                                </div>
                            </Option>
                        );
                    }
                });
                setAllCredentials([...credentials]);
            }
        } catch (err) {
            if (err?.code === 'ERR_CANCELED') {
                console.log('Credentials request canceled.');
                return;
            }
            console.log('Error fetching credentials:', err);
            toggleAlert("error", "Failed", "Failed to fetch credentials list.");
        } finally {
            unregisterAbortController(controller);
        }
    };


    const handleClick = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: ""
            },
        });
    }

    const handleSelectChange = (value, event) => {
        console.log("event :", event);
        // console.log("value :", value);
        
        // Normalize event to handle both single and multiple select modes
        const eventArray = Array.isArray(event) ? event : [event];
        const eventName = eventArray[0]?.props?.name || eventArray[0]?.name;
        
        if (event.name === "redirect" || eventName === "redirect") {
            // handleClick();
            return;
        }

        if (eventName === "selectionType") {
            
            setEcrData({
                selectionType: value,
                accountId: [],
                region: [],
                credentialId: null
            });

            form.setFieldsValue({
                selectionType: value,
                accountId: [],
                region: [],
                credentialId: null
            });
            
            setIsValidated(false);
            setError({status: false, content: {}});
            return;
        }

        if (eventName === "credentialId") {
            setEcrData({ ...ecrData, credentialId: value });
            form.setFieldsValue({...ecrData, credentialId: value});
            setError({status: false, content: {}});
            setIsValidated(false);
            return;
        }

        if(eventName === "accountId"){
            setEcrData({ ...ecrData, accountId: value });
            form.setFieldsValue({...ecrData, accountId: value});
            setIsValidated(false);
            setError({status: false, content: {}});
            return;
        }
        
        if(eventName === "region"){
            setEcrData({ ...ecrData, region: value });
            form.setFieldsValue({...ecrData, region: value});
            setIsValidated(false);
            return;
        }

        // re-validate things if something changes
        // setIsValidated(false);
    };

    const handleValidate = async (arg) => {
        const isSaveFlow = typeof arg === 'boolean' ? arg : false;
        let controller = null;
        try {
            setValidating(true);
            
            // Validate required fields based on selection type
            if (ecrData.selectionType === "credentials") {
                await form.validateFields(['credentialId', 'region']);
                
                // Call API to validate credentials
                const payload = {
                    credential_id: ecrData.credentialId,
                    integration_type: "ecr",
                    regions: ecrData.region,
                };

                controller = registerAbortController();
                const response = await api.post(
                    `${process.env.REACT_APP_API_URI}/api/admin/credentials/validate-credentials/`,
                    payload,
                    { signal: controller.signal }
                );

                console.log("response in /validate-credentials :", response.data.data);

                if (response.data.status) {
                    if(response.data.data?.validation_status?.toLowerCase() === "success") {
                        if (!isSaveFlow) setIsValidated(true);
                        setError({status: false, content: {}});
                        toggleAlert("success", "Success", `Credentials validated successfully. ${isSaveFlow ? "Please wait for the integration to complete." : ""}`);
                        return true;
                    }
                    else if(response.data.data?.validation_status?.toLowerCase() === "failed"){
                        // collect error messages from response.data.data.permissions
                        if(response.data.data.permissions){
                            setError({
                                status: true,
                                msg: response.data.data.message,
                                content: {
                                    ...response.data.data.permissions
                                },
                            });
                        }

                        // show notification with error message
                        let err = formatErrors(response.data.data.message);
                        toggleAlert("error", "Validation/Permission Failed", err);
                        return false;
                    }
                } else {
                    let err = formatErrors(response.data.error_details);
                    toggleAlert("error", "Validation Failed", err);
                    setError({status: false, content: {}});
                    return false;
                }
            } else {
                await form.validateFields(['accountId', 'region']);
                if (!isSaveFlow) setIsValidated(true);
                setError({status: false, content: {}});
                return true;
            }
        } catch (err) {
            if (err?.code === 'ERR_CANCELED') {
                console.log("Validation request canceled.");
                return false;
            }
            if (err?.errorFields) {
                return false;
            }
            console.log("Validation error:", err);
            setError({status: false, content: {}});
            return false;
        } finally {
            if (controller) {
                unregisterAbortController(controller);
            }
            setValidating(false);
        }
    };

    const handleValidateAndSave = async () => {
        const validationSuccess = await handleValidate(true);
        if (validationSuccess) {
            console.log("now going for integration...");
            // handleClick();
            await handleIntegration();
        }
        else {
            console.log("validation failed...");
        }
    };


    const handleIntegration = async (e) => {
        try {
            await form.validateFields();
        }
        catch (err) {
            console.log("Error", err);
            return;
        }

        console.log("inside handleIntegration :", ecrData);
        
        setConnecting(true);
        setLoad((prev) => ({ ...prev, ecr: true }));
        let payload;
        // let controller = null;
        
        if (ecrData.selectionType === "credentials") {
            payload = {
                credential_id: ecrData.credentialId,
                regions: ecrData.region,
            };
        } else {
            payload = {
                account_ids: ecrData.accountId,
                regions: ecrData.region,
            };
        }

        try {
            // controller = registerAbortController();
            const res = await api.post(
                process.env.REACT_APP_API_URI + '/api/integration/ecr-credentials/',
                payload,
                // { signal: controller.signal }
            );
            let data = res.data;
            console.log('data in dockerhub integration :', data);
            if (data.status) {
                setConnected((prev) => !prev);
                toggleAlert("success", "Success", "ECR Account Connected Successfully.");
            }
            else {
                let err = formatErrors(data.error_details);
                console.log("err in /ecr/integration :", err);
                toggleAlert("error", "Failed", err);
            }
        } catch (err) {
            if (err?.code === 'ERR_CANCELED') {
                console.log('Integration request canceled.');
                return;
            }
            toggleAlert("error", "Failed", "Something went wrong");
            console.log('Error in resend-emailverification :', err);
        } finally {
            // if (controller) {
            //     unregisterAbortController(controller);
            // }
            setConnecting(false);
            setLoad((prev) => ({ ...prev, ecr: false }));
            handleClick();
        }
    }

    const handleCancel = () => {
        abortAllPendingRequests();
        setValidating(false);
        setConnecting(false);
        setLoad((prev) => ({ ...prev, ecr: false }));
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
            },
        });
    }

    return (
        <ProdContentHold>
            <CreateTaskHeader
                buttonContent="ECR"
                data={"Yes"}
                // values={{editing: true}}
                onCancel={handleCancel}
                onDelete={onDelete}
                onEditCancel={handleCancel}
            />

            <Form
                form={form}
                name="ecrForms"
                initialValues={ecrData}
            >
                {(validating || connecting) && (
                    <LoaderOverlay>
                        <Spin size="large" />
                    </LoaderOverlay>
                )}

                <Box
                    title={<div style={{ display: "flex", marginTop: "100px" }}><span style={{ marginRight: "5px", color: "red" }}>*</span><span>Integration Type :</span></div>}
                >
                    <ContentHolder>
                        <Form.Item
                            name="selectionType"
                            initialValue={ecrData.selectionType}
                            rules={[
                                {
                                    required: true,
                                    message: "Please select integration type."
                                }
                            ]}
                        >
                            <Select
                                name="selectionType"
                                style={{ width: '100%' }}
                                placeholder="Select type"
                                onChange={handleSelectChange}
                                disabled={validating}
                            >
                                <Option key="account_id" name="selectionType" value="account_id">
                                    Cloud Accounts
                                </Option>
                                <Option key="credentials" name="selectionType" value="credentials">
                                    Credentials
                                </Option>
                            </Select>
                        </Form.Item>
                    </ContentHolder>
                </Box>

                {ecrData.selectionType === "account_id" && (
                    <Box
                        title={<div style={{ display: "flex" }}><span style={{ marginRight: "5px", color: "red" }}>*</span><span>Account ID :</span></div>}
                    >
                        <ContentHolder>
                            {console.log("allAccountIds :", allAccountIds)}
                            <Form.Item
                                name="accountId"
                                rules={[
                                    {
                                        required: ecrData.selectionType === "account_id",
                                        message: "Please select Account ID."
                                    }
                                ]}
                            >
                                <Select
                                    mode={allAccountIds.length > 0 ? "multiple" : "single"}
                                    name="accountId"
                                    style={{ width: '100%' }}
                                    placeholder="Select account Ids"
                                    onChange={handleSelectChange}
                                    disabled={validating}
                                >
                                    {allAccountIds.length > 0 ? allAccountIds :
                                        <Option key="0" name="redirect" data-alias="" type="integration" style={{ color: "white", background: "#1677ff" }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "40px" }}>
                                                <span>No AWS account integration found. Integrate a new account.</span>
                                            </div>
                                        </Option>
                                    }
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>
                )}

                {ecrData.selectionType === "credentials" && (
                    <Box
                        title={<div style={{ display: "flex" }}><span style={{ marginRight: "5px", color: "red" }}>*</span><span>Credentials :</span></div>}
                    >
                        <ContentHolder>
                            <Form.Item
                                name="credentialId"
                                rules={[
                                    {
                                        required: ecrData.selectionType === "credentials",
                                        message: "Please select a credential."
                                    }
                                ]}
                            >
                                <Select
                                    name="credentialId"
                                    style={{ width: '100%' }}
                                    placeholder="Select credential"
                                    onChange={handleSelectChange}
                                    disabled={validating}
                                >
                                    {allCredentials.length > 0 ? allCredentials :
                                        <Option key="no-creds" disabled>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <span>No active AWS credentials found.</span>
                                            </div>
                                        </Option>
                                    }
                                </Select>
                            </Form.Item>
                        </ContentHolder>
                    </Box>
                )}

                <Box
                    title={<div style={{ display: "flex" }}><span style={{ marginRight: "5px", color: "red" }}>*</span><span>Region :</span></div>}
                    style={{ marginBottom: (error.status && !validating) ? "0px" : "150px" }}
                >
                    <ContentHolder>
                        <Form.Item
                            name="region"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select region."
                                }
                            ]}
                        >
                            <Select
                                mode="multiple"
                                name="region"
                                style={{ width: '100%' }}
                                placeholder="Select regions"
                                onChange={handleSelectChange}
                                disabled={validating}
                            >
                                {allRegions}
                            </Select>
                        </Form.Item>
                        {/* <Select
                        style={{ width: '400px' }}
                        defaultValue={ecrData.region}
                        onChange={handleSelectChange}
                    >
                        {allRegions}
                    </Select> */}
                    </ContentHolder>
                </Box>

                {/* <Box>
                    <ContentHolder style={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px"
                    }}>
                        {(ecrData.selectionType === "credentials" && !isValidated) && (
                            <Button
                                type="primary"
                                onClick={handleValidate}
                                disabled={validating}
                                style={{ marginTop: "-20px", fontSize: "16px", fontFamily: "Nunito Sans", fontWeight: "500", backgroundColor: "#132f44", padding: "5px 40px", height: "auto", color: "white" }}
                            >
                                {validating ? (
                                    <span style={{display: "flex", alignItems: "baseline"}}>
                                        <Spin size="small" style={{ marginRight: "10px" }} />
                                        Validating...
                                    </span>
                                ) : (
                                    "Validate"
                                )}
                            </Button>
                        )}
                        {(ecrData.selectionType === "account_id" || (isValidated && !error.status)) && (
                            <Button 
                                type="primary" 
                                onClick={handleIntegration} 
                                style={{ marginTop: "-20px", fontSize: "16px", fontFamily: "Nunito Sans", fontWeight: "500", backgroundColor: "#132f44", padding: "5px 40px", height: "auto", color: "white" }}
                            >
                                Connect
                            </Button>
                        )}
                    </ContentHolder>
                </Box> */}
                
                {/* show errors if any */}
                {error.status && !validating && (
                    <Box style={{ marginBottom: "150px" }}>
                        <ContentHolder style={{ marginTop: "0px" }}>
                            <span style={{ fontSize: "16px", fontFamily: "Nunito Sans", fontWeight: "500", color: "#d20a0a" }}>*{error.msg}</span>
                            
                            {permissionColumns.length > 0 && Object.keys(error.content).length > 0 && <div style={{ overflowX: "auto" }}>
                                <table
                                    style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        fontFamily: "'Nunito Sans', sans-serif",
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left", padding: "12px 16px", borderBottom: "1px solid #e5e5e5", fontWeight: 600, color: "#132f44" }}>
                                                Region
                                            </th>
                                            {permissionColumns.map((column) => (
                                                <th
                                                    key={`head-${column.key}`}
                                                    style={{ textAlign: "center", padding: "12px 16px", borderBottom: "1px solid #e5e5e5", fontWeight: 600, color: "#132f44" }}
                                                >
                                                    {column.label}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(error.content).map((region) => (
                                            <tr key={region}>
                                                <td style={{ padding: "12px 16px", borderBottom: "1px solid #f0f0f0", fontWeight: 500 }}>
                                                    {region}
                                                </td>
                                                {permissionColumns.map((column) => {
                                                    const permissionStatus = error.content[region]?.[column.key];
                                                    const isSuccess = permissionStatus === true;
                                                    const isFailure = permissionStatus === false;
                                                    const tooltipText = permissionTooltips[column.key] || "IAM policy missing for this permission.";
                                                    return (
                                                        <td
                                                            key={`${region}-${column.key}`}
                                                            style={{ padding: "12px 16px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}
                                                        >
                                                            {(isSuccess || isFailure) ? (
                                                                isSuccess ? (
                                                                    <CheckCircleFilled style={{ fontSize: 18, color: "#0f9d58" }} />
                                                                ) : (
                                                                    <Tooltip title={tooltipText} placement="top">
                                                                        <CloseCircleFilled style={{ fontSize: 18, color: "#d20a0a", cursor: "help" }} />
                                                                    </Tooltip>
                                                                )
                                                            ) : (
                                                                <span style={{ color: "#999999" }}>—</span>
                                                            )}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>}
                        </ContentHolder>
                    </Box>
                )}
            </Form>

            {/* Footer Buttons */}
            <CreateTaskFooter buttonContent={"ecr"} givenButtonFunction1={handleValidate} givenButtonFunction2={handleIntegration} givenButtonFunction3={handleValidateAndSave} disabled={validating || connecting} isValidated={isValidated} showOnlyConnectButton={ecrData.selectionType === "account_id" ? true : false} />
        </ProdContentHold>
    );
};
